module.exports = __webpack_public_path__ + "static/biology-f8802119924c29835259bf94f8052d30.svg";